import {dismissMentorshipFormedDialog} from "actions/authAction";
import {addSlot, bookCall, refreshCallSlots, removeSlot} from "actions/callSlotsAction";
import {getChatChannels, toggleMessageWindow} from "actions/chatAction";
import {loadEvents} from "actions/eventsAction";
import {initMentorship, initMentorshipSessions} from "actions/mentorshipAction";
import {filter, get} from "lodash";
import {isMentee, isMentor} from "business/role";
import {connect} from 'react-redux';
import MentorshipHome from "views/Mentorship/MentorshipHome";

const mapStateToProps = ({
                           mentorship: {sessions, partnerDetails, callSlots, suggestedCallTimes},
                           event: {events, eventsLoaded},
                           chat: {chatChannels},
                           auth: {user, mentorshipFormedDialogPendingFor},
                         }) => {
  const mentorship = get(user, 'status.mentorships[0]');
  // The reducer seeds partnerDetails with {} until the mentorship is fetched.
  const roster = get(partnerDetails, 'partnerDetails');

  return {
    mentorshipId: get(mentorship, 'id'),
    mentorshipFormedDialogPendingFor,
    events,
    eventsLoaded,
    sessions,
    members: Array.isArray(roster) ? roster : [],
    selfPicture: get(user, 'picture'),
    chatChannels,
    mentorGroup: get(partnerDetails, 'mentorGroup'),
    groupMentorshipId: get(partnerDetails, 'id'),
    // Same sources as the events page, so a call booked here matches one
    // booked from the form.
    profileId: get(partnerDetails, 'userDetails[0].id'),
    mentorshipGroupId: get(user, 'status.mentorGroup', null),
    callSlots,
    suggestedCallTimes,
    isMentor: isMentor(get(user, 'role')),
    menteeCount: filter(roster, member => isMentee(member.role)).length,
    self: {
      id: get(user, 'id'),
      firstName: get(user, 'firstName', ''),
      lastName: get(user, 'lastName', ''),
    },
  };
};

export default connect(mapStateToProps, {
  initMentorship,
  initMentorshipSessions,
  loadEvents,
  getChatChannels,
  toggleMessageWindow,
  dismissMentorshipFormedDialog,
  refreshCallSlots,
  addSlot,
  removeSlot,
  bookCall,
})(MentorshipHome);
